export default __webpack_public_path__ + "static/media/img-erb-placeholder.3dcede96.svg";